import {useAppSelector} from "@/store";
import {MessageTemplateState} from "@/store/slices/whatsapp-template";

export const useMessageTemplateStore = (): MessageTemplateState => {
    return useAppSelector(state => state.messageTemplate)
}
